import { mapState } from 'vuex';
import n20ActionButtonMixin from './n20ActionButtonMixin';
export default {
  name: 'CoreN20Card',
  mixins: [n20ActionButtonMixin],
  inheritAttrs: false,
  props: {
    border: {
      type: String,
      default: ''
    },
    inline: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    offset: {
      type: [Number, String],
      default: 40
    },
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    note: {
      type: String,
      default: ''
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled']),
    hasOffset() {
      return this.hasButtons || !!this.$slots.buttons || !!this.title || !!this.icon || !!this.note;
    },
    styles() {
      if (!this.hasOffset) {
        return null;
      }
      return {
        marginTop: `${parseInt(this.offset) * 2 + 2}px`
      };
    },
    cloading() {
      return this.$store.state.app.loading;
    },
    cardStyles() {
      if (!this.hasButtons && !this.$slots.buttons) {
        return {
          'max-width': `calc(100% - ${24}px)`
        };
      } else {
        let width = 50;
        this.buttons.forEach(button => {
          if (button.title) {
            width += button.title.length * 7 + 80;
          } else {
            width += 50;
          }
        });
        if (width > 400) {
          return {
            display: 'none'
          };
        }
        return {
          'max-width': `calc(100% - ${width}px)`
        };
      }
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    borderStyle(item = 'border') {
      if (this.border) {
        return `${item}: ${this.border}`;
      }
      return '';
    }
  }
};